export default __webpack_public_path__ + "static/media/css.60a6c50d.svg";